import React, { Component } from "react";
import { Well, Row, Col } from "react-bootstrap";
import TypeWordCheckboxItem from "./TypeWordCheckboxItem";

export default class TypeWordCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectTypeAll: true,
    };
    this.typeSelectAll = this.typeSelectAll.bind(this);
  }
  typeSelectAll(e) {
    this.setState({ selectTypeAll: e.target.checked });
  }

  render() {
    let rowContents = [];
    const list = this.props.data.reduce((acc, item, i) => {
      rowContents.push(
        <TypeWordCheckboxItem
          key={i}
          checkedAll={this.state.selectTypeAll}
          value={item.value}
          name={this.props.name}
          label={item.label}
        />
      );
      if ((i + 1) % 8 === 0 || i + 1 === this.props.data.length) {
        acc.push(
          <Col key={i} md={3}>
            <ul style={{ listStyleType: "none" }}>{rowContents}</ul>
          </Col>
        );
        rowContents = [];
      }
      return acc;
    }, []);

    return (
      <Well>
        <h5>Word type</h5>
        <input
          id="wordtypeinput"
          type="checkbox"
          checked={this.state.selectTypeAll}
          onChange={this.typeSelectAll}
        />
        {` `}Select all
        <br />
        <Row>{list}</Row>
      </Well>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/Forms/TypeWordCheckbox.jsx